<template>
    <div style="height: inherit">
        <component v-if="errorPage" :is="errorPage" :payload="payload"/>
        <router-view v-else/>

        <template v-for="modal in modals">
            <component :is="modal.component" v-bind="modal" :key="modal.id"/>
        </template>
    </div>
</template>

<script>
import ResponseAlertConfirm from '@/iamteacherpc/components/response/ResponseAlertConfirm.vue';
import {lock, unlock} from 'tua-body-scroll-lock';
import {
    EVENT_CLOSE_MODAL,
    EVENT_SHOW_ALERT,
    EVENT_SHOW_CONFIRM,
    EVENT_SHOW_ERROR_PAGE,
    EVENT_SHOW_MODAL,
} from '@common/utils/event.js';

export default {
        name: 'App',

        data() {
            return {
                errorPage: false,
                payload: null,
                modals: [],
                disableBodyScroll: false,
            }
        },

        created() {
            this.$eventBus.$on(EVENT_SHOW_ERROR_PAGE, this.showErrorPage);
            this.$eventBus.$on(EVENT_SHOW_CONFIRM, this.showConfirm);
            this.$eventBus.$on(EVENT_SHOW_ALERT, this.showAlert);
            this.$eventBus.$on(EVENT_CLOSE_MODAL, this.closeModal);
            this.$eventBus.$on(EVENT_SHOW_MODAL, this.showModal);
        },

        watch: {
            '$route'() {
                this.component = false;
            },

            'modals.length'(modalCount) {
                if (modalCount && !this.disableBodyScroll) {
                    this.disableBodyScroll = true;
                    lock();
                } else if (!modalCount && this.disableBodyScroll) {
                    this.disableBodyScroll = false;
                    unlock();
                }
            }
        },

        methods: {
            showErrorPage({component, payload}) {
                this.errorPage = component;
                this.payload = payload;
            },

            showConfirm(payload) {
                this.showModal({
                    type: 'confirm',
                    component: ResponseAlertConfirm,
                    ...payload
                });
            },

            showAlert(payload) {
                this.showModal({
                    type: 'alert',
                    component: ResponseAlertConfirm,
                    ...payload
                });
            },

            showModal(payload) {
                const id = this.getNextModalSequence();

                this.modals.push({
                    ...payload,
                    id,
                });

                history.pushState({
                    ...history.state,
                    modalIds: this.getModalIdInfo(),
                }, '');
            },

            closeModal({id}) {
                const modal = this.modals.find(m => m.id === id);
                this.modals = this.modals.filter(m => m.id !== id);

                if (modal.afterClose) {
                    modal.afterClose();
                }
            },

            getNextModalSequence() {
                return new Date().getTime();
            },

            getModalIdInfo() {
                return this.modals.map(m => m.id);
            },
        }
    }
</script>
